// images
import p11 from '../../assets/p1/1.jpg';
import p12 from '../../assets/p1/2.jpg';
import p13 from '../../assets/p1/3.jpg';
import p14 from '../../assets/p1/4.jpg';
import p15 from '../../assets/p1/5.jpg';
import p16 from '../../assets/p1/6.jpg';
import p17 from '../../assets/p1/7.jpg';
import p18 from '../../assets/p1/8.jpg';
import p21 from '../../assets/p2/1.jpg';
import p22 from '../../assets/p2/2.jpg';
import p23 from '../../assets/p2/3.jpg';
import p24 from '../../assets/p2/4.jpg';
import p25 from '../../assets/p2/5.jpg';
import p31 from '../../assets/p3/1.jpg';
import p32 from '../../assets/p3/2.jpg';
import p33 from '../../assets/p3/3.jpg';
import p34 from '../../assets/p3/4.jpg';
import p35 from '../../assets/p3/5.jpg';
import p36 from '../../assets/p3/6.jpg';
import p37 from '../../assets/p3/7.jpg';


const images = [
	[p18, p12, p13, p14, p15, p16, p17, p11],
	[p21, p22, p23, p24, p25],
	[p33, p32, p31, p34, p35, p36, p37],
];

export default images